import { render, staticRenderFns } from "./MobileFilesystemHeader.vue?vue&type=template&id=49601044&"
import script from "./MobileFilesystemHeader.vue?vue&type=script&lang=js&"
export * from "./MobileFilesystemHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports